import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    Card,
    CardContent,
    FormControl,
    Grid, IconButton, Input, InputAdornment,
    Switch,
    Typography, Select
} from "@deere/fuel-react";
import {useAuthConfig} from "../shared/helper";
import SearchIcon from "@material-ui/icons/Search";
import {Controller} from "react-hook-form";
import {DataGrid} from "@mui/x-data-grid";
import AddIcon from "@material-ui/icons/Add";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import { makeStyles } from '@material-ui/core/styles';
import {getOptionSelected} from "../shared/utils/autocompleteUtils";

const useStyles = makeStyles((theme) => ({
    selected: {
        "&.Mui-selected, &.Mui-selected:hover": {
        backgroundColor: '#fff',
        color: '#367c2b',
        border : '1px solid #367c2b'
      }
    }
  }));

export const SupplierUnitsCard = ({control, supplierNumber}) => {
    const classes = useStyles();
    let authAxios = useAuthConfig();
    const [supplierUnits, setSupplierUnits] = useState([]);
    const [selectedSupplierUnits, setSelectedUnits] = useState([]);
    const [unitList, setUnitList] = useState([]);
    const [yesNoList, setYesNoList] = useState([]);
    const [option, setOption] = useState("ship");

    const children = [
        <ToggleButton
            classes={{ selected: classes.selected }}
            value="ship"
            aria-label="ship"
            key="1"
            style={{lineHeight: "10px"}}> &nbsp; Ship &nbsp; </ToggleButton>,
        <ToggleButton
            classes={{ selected: classes.selected }}
            value="due"
            aria-label="due"
            key="2"> &nbsp; Due &nbsp; </ToggleButton>
    ];

    const columns = [
        {
            field: 'id',
            headerName: 'ID',
            hide: true
        },
        {
            field: 'unit',
            headerName: 'Units',
            flex: 1,
            renderCell: (params) => {
                return (
                    <Autocomplete
                        fullWidth
                        size="small"
                        id="unit-find"
                        options={unitList}
                        defaultValue={params.row.unit}
                        value={params.row.unit}
                        getOptionLabel={(option) => option.description}
                        getOptionSelected={getOptionSelected}
                        onChange={(e, value) => {
                            console.log(value, params.row.id)
                        }}
                        renderInput={(params) => <TextField {...params}
                                                            placeholder="Select Unit"
                                                            variant="outlined"/>}
                    />
                )
            }
        },
        {
            field: 'autoAdjust',
            headerName: 'Auto Adjust',
            flex: 0.85,
            renderCell: (params) => {
                return (
                    <>
                        <Switch name="adjust" onChange={handleStatusUpdate}/>
                        <Input placeholder="mmm"
                               style={{width: "80px", margin: ".5em"}}
                               id="month"
                               onChange={(e) => {
                                   console.log(e.target.value)
                               }}
                        />
                        <Input placeholder="YYYY"
                               style={{width: "80px"}}
                               id="year"
                               onChange={(e) => {
                                   console.log(e.target.value)
                               }}
                        />
                    </>
                );
            }
        },
        {
            field: 'shipBy',
            headerName: 'Ship or Due Date',
            flex: 1,
            renderCell: (params) => {
                return (
                    <>
                        <ToggleButtonGroup
                            aria-label="ship due toggle"
                            exclusive
                            onChange={handleChange}
                            style={{height: "40px", color: "#333333"}}
                            value={option}
                        >
                            {children}
                        </ToggleButtonGroup>
                        <Input placeholder="mmm"
                               style={{width: "80px", margin: ".5em"}}
                               id="month"
                               onChange={(e) => {
                                   console.log(e.target.value)
                               }}
                        />
                        <Input placeholder="YYYY"
                               style={{width: "80px"}}
                               id="year"
                               onChange={(e) => {
                                   console.log(e.target.value)
                               }}
                        />
                    </>
                );
            }
        },
        {
            field: 'shipByInd',
            headerName: 'Ship Date Indicator',
            flex: .65,
            renderCell: (params) => {
                return (
                    <Controller
                        control={control}
                        defaultValue={params.row.shipByInd}
                        name={"shipByInd"}
                        render={({onChange, value}) => (
                            <Select native
                                    labelId={"shipByInd"}
                                    id={"shipByInd"}
                                    value={value}
                                    onChange={(e) => {
                                        onChange(e);
                                    }}>
                                {yesNoList && yesNoList.map((item, index) => {
                                    return (
                                        <option
                                            key={index}
                                            value={item}>{item}</option>
                                    );
                                })
                                }
                            </Select>
                        )}
                    />
                );
            }
        }
    ];

    const rowsData = supplierUnits && supplierUnits.map((item) => {
        return {
            id: item.id,
            autoAdjust: item.autoAdjust,
            unit: item.unit,
            shipBy: item.shipBy,
            shipByInd: item.shipByInd
        };
    });

    const handleChange = (event, newOption) => {
        setOption(newOption);
    };

    const handleRowSelection = (data, e) => {
        setSelectedUnits(e)
        console.log(data, e);
    }

    const handleStatusUpdate = (e) => {
        console.log(e);
    }

    const getUnits = async () => {
        try {
            return await authAxios.get(`/units`);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (supplierNumber) {
            getUnits().then(res => {
                setUnitList(res.data);
            });
            setSupplierUnits([
                {
                    "id": 1,
                    "unit": {"id": "1000", "description": "AG Marketing Center/JDAMC"},
                    "autoAdjust": {
                        "status": true,
                        "month": "Mar",
                        "Year": "2000"
                    },
                    "shipByInd": "Y",
                    "shipBy": {
                        "status": true,
                        "month": "May",
                        "Year": "2000"
                    }
                },
                {
                    "id": 2,
                    "unit": {"id": "LV00", "description": "Augusta / Commercial Product"},
                    "autoAdjust": {
                        "status": false,
                        "month": "",
                        "Year": ""
                    },
                    "shipByInd": "N",
                    "shipBy": {
                        "status": false,
                        "month": "",
                        "Year": ""
                    }
                },
                {
                    "id": 3,
                    "unit": {"id": "H 00", "description": "Harvester Works- East Moline"},
                    "autoAdjust": {
                        "status": false,
                        "month": "",
                        "Year": ""
                    },
                    "shipByInd": "",
                    "shipBy": {
                        "status": false,
                        "month": "",
                        "Year": ""
                    }
                }
            ])
        }
        setYesNoList(["Select Code...", "Y", "N"])
        return () => {
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Card>
            <CardContent>
                <Grid container alignItems="flex-start" spacing={4}>
                    <Grid item xs={12}>
                        <Box display="flex" justifyContent="flex-start">
                            <Typography variant="h4">
                                {`(${0})`}
                                {" "} Units Included
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={3}>
                        <Box display="flex" justifyContent="flex-start">
                            <Button variant="primary" startIcon={<AddIcon/>}> Add
                                Units </Button>
                        </Box>
                    </Grid>
                    <Grid item xs={9}>
                        <FormControl fullWidth>
                            <Input fullWidth placeholder="Search"
                                   id="search"
                                   endAdornment={
                                       <InputAdornment position="end">
                                           <IconButton aria-label="search">
                                               <SearchIcon style={{color: " #367c2b"}}/>
                                           </IconButton>
                                       </InputAdornment>
                                   }
                                   onChange={(e) => {
                                       console.log(e.target.value)
                                   }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <FormControl required fullWidth style={{height: 275}}>
                            <Controller
                                rules={{required: true}}
                                control={control}
                                name="selectedSupplierUnits"
                                defaultValue={supplierUnits}
                                value={selectedSupplierUnits}
                                render={({onChange, value}) => (
                                    <DataGrid
                                        rows={rowsData}
                                        columns={columns}
                                        hideFooterPagination
                                        checkboxSelection
                                        hideFooterSelectedRowCount
                                        disableSelectionOnClick
                                        disableColumnSelector={true}
                                        disableColumnFilter
                                        onSelectionModelChange={(ids) => {
                                            const selectedIDs = new Set(ids);
                                            const selectedRowData = rowsData.filter((row) =>
                                                selectedIDs.has(row.id)
                                            );
                                            onChange(selectedRowData, ids);
                                            handleRowSelection(selectedRowData, ids);
                                        }}
                                        selectionModel={(() => {
                                            return selectedSupplierUnits;
                                        })()}
                                    />
                                )}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}
